/** Precision monetaria efectiva del tenant activo en el PWA. */
import { formatCurrency } from './format';

export type MonetaryPrecisionResponse = {
  fallback_decimals: number;
  fields: Record<string, number>;
};

export type MonetaryPrecision = {
  fallbackDecimals: number;
  decimals: (table: string, field: string) => number;
  round: (table: string, field: string, value: number | string | null | undefined) => number;
  format: (
    table: string,
    field: string,
    value: number | string | null | undefined,
    currency?: string,
  ) => string;
};

export const DEFAULT_MONETARY_PRECISION: MonetaryPrecision = createMonetaryPrecision();

export function createMonetaryPrecision(
  raw?: MonetaryPrecisionResponse | null,
): MonetaryPrecision {
  const fallbackDecimals = Number.isInteger(raw?.fallback_decimals)
    ? Number(raw?.fallback_decimals)
    : 2;
  const fields = raw?.fields ?? {};
  const decimals = (table: string, field: string) =>
    fields[`${table}.${field}`] ?? fallbackDecimals;
  return {
    fallbackDecimals,
    decimals,
    round: (table, field, value) => {
      const factor = 10 ** decimals(table, field);
      return Math.round((Number(value) || 0) * factor) / factor;
    },
    format: (table, field, value, currency) =>
      formatCurrency(value, currency, decimals(table, field)),
  };
}
